import React from "react";
import { Box } from "@mui/system";
import "./layoutBackGround.css";
import { Typography } from "@mui/material";
import MultiStepRegistration from "./RegistrationProgress";
import { useLayoutContent } from "./layoutContentContext";

function extractLinesFromFirstParagraph(htmlString: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const lines = [];
  const firstP = doc.querySelector("p");

  if (firstP) {
    let currentText = "";
    firstP.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        currentText += node.textContent;
      } else if (node.nodeName === "BR") {
        lines.push(currentText.trim());
        currentText = "";
      }
    });
    if (currentText.trim()) {
      lines.push(currentText.trim());
    }
  }

  return lines;
}

const LayoutWithBackground = ({ children, containerClass = "" }: any) => {
  const { layoutContent } = useLayoutContent();
  const isEasyLogin = !!sessionStorage.getItem("login_hash_key");

  const layoutContentMemo = React.useMemo(() => {
    if (!layoutContent) return [];
    return extractLinesFromFirstParagraph(layoutContent);
  }, [layoutContent]);
  return (
    <div className={`background-with-layout-container ${containerClass}`}>
      <Box className="split-layout">
        {/* Left Column - Hidden on mobile */}
        <Box
          className="left-column"
          sx={{
            backgroundColor: "#01205F",
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "70%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignContent: "center",
              gap: "30px",
              height: "100%",
              paddingTop: "5%",
              margin: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "30px",
              }}
            >
              <img
                src="https://public.ticca.com/images/logo/Logo_white.svg"
                alt=""
                width={"150px"}
                height={"40px"}
              />
              <Typography
                sx={{
                  fontFamily: `'Poppins', sans-serif`,
                  fontWeight: 600,
                  fontSize: "38px",
                  lineHeight: 1,
                  letterSpacing: 0,
                  color: "#FFFFFF",
                }}
              >
                {layoutContentMemo[0]}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {layoutContentMemo.slice(1).map((line, index) => (
                  <Typography
                    key={index}
                    sx={{
                      fontFamily: `'Poppins', sans-serif`,
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: 1,
                      letterSpacing: 0,
                      color: "#B5C3E0",
                    }}
                  >
                    {line}
                  </Typography>
                ))}
              </Box>
              {isEasyLogin && <MultiStepRegistration />}
            </Box>
            {/* {layoutContentMemo.slice(1).map((line, index) => (
              <Typography
                key={index}
                sx={{
                  fontFamily: `'Poppins', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: 1,
                  letterSpacing: 0,
                  color: '#B5C3E0'
                }}>
                {line}
              </Typography>
            ))} */}
          </Box>

          <Box
            component="img"
            alt="Logo"
            src="https://public.ticca.com/images/png/WhyTransformingTheFutureOfRemoteWork.png"
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "80%",
              // height: 'auto', // Maintain aspect ratio
              // minHeight: '30%', // Minimum height to ensure visibility
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain", // Ensures proper scaling
            }}
          />
        </Box>

        {/* Right Column - Always visible */}
        <Box
          className="right-column"
          sx={{
            width: { xs: "100%", md: "auto" }, // Take full width on mobile
          }}
        >
          {children}
        </Box>
      </Box>
    </div>
  );
};

export default LayoutWithBackground;
